import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { statisticsPages } from '../../../constants/statisticsPages';
import { markMapKeys, markNames } from '../constants/marks';

const useHiddenMarksItem = () => {
  const [hiddenMarksItem, setHiddenMarksItem] = useState();

  const params = useParams();

  useEffect(() => {
    let item;

    switch (params.page) {
      case statisticsPages.immediate:
        item = markMapKeys[markNames.isImmediate];
        break;
      case statisticsPages.expired:
        item = markMapKeys[markNames.expired];
        break;
      case statisticsPages.retry:
        item = markMapKeys[markNames.isRetry];
        break;
      case statisticsPages.chargeable:
        item = markMapKeys[markNames.isChargeable];
        break;
    }

    setHiddenMarksItem(item);
  }, [params.page]);

  return hiddenMarksItem;
};

export default useHiddenMarksItem;
